import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.propocrm.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - token'ı her istekte ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401 hatalarını handle et
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token geçersiz, login sayfasına yönlendir
      const currentPath = window.location.pathname;
      if (currentPath !== '/login') {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }

    if (error.response?.status === 403 && error.response.data?.requires_subscription) {
      const currentPath = window.location.pathname;
      if (currentPath !== '/subscription-expired') {
        window.location.href = '/subscription-expired';
      }
    }
    
    // 404 hatalarını console'a yazdırma (geliştirme aşamasında endpoint'ler hazır olmayabilir)
    if (error.response?.status === 404) {
      // Sessizce handle et, console'a yazdırma
      error.config.silent404 = true;
    }
    
    return Promise.reject(error);
  }
);

export default api;
